import api from '@shared/services/api';

export const noticePeriodService = {
    getNoticePeriodById: async (id) => {
        const response = await api.get(`/hr-termination-note-period/${id}`);
        return response.data;
    },
    getNoticePeriods: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        if (params.pageNumber !== undefined) queryParams.append('pageNumber', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('pageSize', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortDir', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-termination-note-period${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    getNoticePeriodsList: async () => {
        const response = await api.get('/hr-termination-note-period-list');
        return response.data;
    },
    createNoticePeriod: async (data) => {
        const response = await api.post('/hr-termination-note-period', data);
        return response.data;
    },
    updateNoticePeriod: async (id, data) => {
        const response = await api.put(`/hr-termination-note-period/${id}`, data);
        return response.data;
    },
    deleteNoticePeriod: async (id) => {
        const response = await api.delete(`/hr-termination-note-period/${id}`);
        return response.data;
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-termination-note-period/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-termination-note-period/translate', data);
        return response.data;
    },
};

